// extracted by mini-css-extract-plugin
module.exports = {"container":"NavBarOrderTimeSwitch_container__cEQpK","navBar":"NavBarOrderTimeSwitch_navBar__TshNx","capitalize":"NavBarOrderTimeSwitch_capitalize__QcrvL"};